import { safeImport } from './safeImport.js';

// Parse Anki .apkg using JSZip + sql.js (both loaded dynamically to avoid large bundle on initial load)
export async function parseAnkiFile(file) {
    const [JSZip, initSqlJs] = await Promise.all([
        safeImport(() => import('jszip'), 'Anki import').then(m => m.default),
        safeImport(() => import('sql.js'), 'Anki import').then(m => m.default),
    ]);
    // CDN version must match the installed sql.js package (frontend/package.json) — the
    // WASM loader requests version-specific filenames, so a stale pin 404s and aborts.
    const SQL = await initSqlJs({ locateFile: file => `https://cdnjs.cloudflare.com/ajax/libs/sql.js/1.14.1/${file}` });
    const zip = await JSZip.loadAsync(file);

    // Try collection.anki21 first (Anki 2.1), then collection.anki2 (Anki 2.0)
    const dbFile = zip.file('collection.anki21') || zip.file('collection.anki2');
    if (!dbFile) throw new Error('No Anki collection found in .apkg file.');

    const dbBuf = await dbFile.async('arraybuffer');
    const db = new SQL.Database(new Uint8Array(dbBuf));

    // notes table: flds = fields joined by \x1f
    const res = db.exec('SELECT flds, tags FROM notes LIMIT 2000');
    db.close();

    const cards = [];
    if (res.length > 0) {
        for (const row of res[0].values) {
            const fields = String(row[0]).split('\x1f');
            if (fields.length >= 2) {
                const question = fields[0].replace(/<[^>]+>/g, '').trim();
                const answer = fields[1].replace(/<[^>]+>/g, '').trim();
                if (question && answer) cards.push({ question, answer });
            }
        }
    }
    return cards;
}
